import { KeyboardEvent } from "react";
import { cn } from "@tellescope/design-system";

export interface PurchaseCardProps {
  title: string;
  amount: string;
  description?: string;
  date?: string;
  onClick?: () => void;
  className?: string;
}

export const PurchaseCard = ({ title, amount, description, date, onClick, className }: PurchaseCardProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={onClick ? handleKeyDown : undefined}
      className={cn(
        "flex flex-col gap-1 rounded-lg border bg-background px-4 py-3 text-left",
        onClick && "cursor-pointer transition-shadow hover:shadow-md",
        className
      )}
      data-testid="contact-details-block-item"
    >
      <div className="flex items-start justify-between gap-4">
        <p className="min-w-0 truncate text-sm text-foreground">{title}</p>
        <p className="shrink-0 text-sm text-muted-foreground">{amount}</p>
      </div>

      {(description || date) && (
        <div className="flex items-end justify-between gap-4">
          <p className="min-w-0 truncate text-xs text-muted-foreground">{description}</p>
          <p className="shrink-0 text-xs text-muted-foreground">{date}</p>
        </div>
      )}
    </div>
  );
};
